var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 26H21C21.7072 26 22.3855 25.719 22.8856 25.219C23.3857 24.7189 23.6666 24.0406 23.6666 23.3333V15.5733C23.6666 14.5384 23.4255 13.5177 22.9626 12.592L21.704 10.0747C21.2411 9.14901 21.0001 8.12828 21 7.09333V4.66667C21 3.95942 20.719 3.28115 20.2189 2.78105C19.7188 2.28095 19.0406 2 18.3333 2H7.66665C6.9594 2 6.28113 2.28095 5.78103 2.78105C5.28093 3.28115 4.99998 3.95942 4.99998 4.66667V8.66667M4.99998 26C4.29274 26 3.61446 25.719 3.11436 25.219C2.61426 24.7189 2.33331 24.0406 2.33331 23.3333V15.5733C2.33338 14.5384 2.57441 13.5177 3.03731 12.592L4.99998 8.66667M4.99998 26C5.70722 26 6.3855 25.719 6.8856 25.219C7.3857 24.7189 7.66665 24.0406 7.66665 23.3333V15.5733C7.66658 14.5384 7.42555 13.5177 6.96265 12.592L4.99998 8.66667M11.6666 7.33333H14.3333M13 18C13 18.7072 13.2809 19.3855 13.781 19.8856C14.2811 20.3857 14.9594 20.6667 15.6666 20.6667C16.3739 20.6667 17.0522 20.3857 17.5523 19.8856C18.0524 19.3855 18.3333 18.7072 18.3333 18C18.3333 17.2928 18.0524 16.6145 17.5523 16.1144C17.0522 15.6143 16.3739 15.3333 15.6666 15.3333C14.9594 15.3333 14.2811 15.6143 13.781 16.1144C13.2809 16.6145 13 17.2928 13 18Z",
    stroke: "#66c2ed",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.d33a1aa70ae13e2fec3ee95c41c39250.svg";
export { ForwardRef as ReactComponent };